module.exports = __webpack_public_path__ + "img/progress-bar-complete.svg?2448ad3bdb2a4d7a2543a9aec4d01c8a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/img/progress/progress-bar-complete.svg
// module id = 265
// module chunks = 0